module.exports = __webpack_public_path__ + "static/media/table-popup.c03d4a92.png";